import politiciansJson from '../data/politicians.json';
import creditsJson from '../data/credits.json';
import type { Credit, Politician } from './types';

export const politicians = (politiciansJson as Politician[])
  .slice()
  .sort((a, b) => a.name.localeCompare(b.name, 'sk'));

export const credits = new Map((creditsJson as Credit[]).map((c) => [c.id, c]));

const byId = new Map(politicians.map((p) => [p.id, p]));

export function getPolitician(id: string): Politician | undefined {
  return byId.get(id);
}

export function photoUrl(p: Politician): string | null {
  return credits.has(p.id) ? `${import.meta.env.BASE_URL}img/${p.id}.jpg` : null;
}

/** Lowercase and strip diacritics, so "sutaj" finds "Šutaj". */
export function fold(text: string): string {
  return text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
}
